import React from "react";
import { Lock } from "lucide-react";
import { inputCls, labelCls } from "@/components/nds/windows/resident/ui";

const chip = (on) => `px-3 py-2 rounded-sm border text-sm text-left transition-colors ${on ? "border-nex-gold bg-nex-gold/10 text-nex-gold" : "border-white/10 text-nex-silver hover:border-white/30"}`;

/** One questionnaire field: text / tel / email / date / number / ssn4 / textarea / choice / yesno / multi. */
export function QField({ f, value, onChange, locked, phiSection }) {
  const id = `q-${f.key}`;
  const opts = f.options || [];
  const multi = Array.isArray(value) ? value : [];
  let input;
  if (f.type === "textarea") input = <textarea id={id} rows={3} disabled={locked} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={id} className={inputCls} />;
  else if (["choice", "yesno"].includes(f.type)) input = (
    <div className={`grid gap-2 ${f.type === "yesno" ? "grid-cols-2 max-w-xs" : "sm:grid-cols-2"}`}>
      {opts.map(([v, l]) => <button key={v} type="button" disabled={locked} onClick={() => onChange(value === v ? "" : v)} data-testid={`${id}-${v}`} className={chip(value === v)}>{l}</button>)}
    </div>);
  else if (f.type === "multi") input = (
    <div className="grid gap-2 sm:grid-cols-2">
      {opts.map(([v, l]) => <button key={v} type="button" disabled={locked} onClick={() => onChange(multi.includes(v) ? multi.filter((x) => x !== v) : [...multi, v])} data-testid={`${id}-${v}`} className={chip(multi.includes(v))}>{l}</button>)}
    </div>);
  else input = (
    <input id={id} disabled={locked} value={value || ""} onChange={(e) => onChange(f.type === "ssn4" ? e.target.value.replace(/\D/g, "").slice(0, 4) : e.target.value)} data-testid={id}
      type={{ date: "date", number: "number", email: "email", tel: "tel" }[f.type] || "text"} inputMode={f.type === "ssn4" ? "numeric" : undefined} className={`${inputCls} [color-scheme:dark] ${f.type === "ssn4" ? "!w-28" : ""}`} />);
  return (
    <div className="space-y-1.5" data-testid={`${id}-wrap`}>
      <label htmlFor={id} className={labelCls}>{f.label}{f.required && <span className="text-nex-gold"> *</span>}{(f.phi || phiSection) && <Lock className="inline h-2.5 w-2.5 ml-1 text-nex-gold/70" />}</label>
      {f.hint && <p className="text-xs text-nex-muted">{f.hint}</p>}
      {input}
    </div>
  );
}
